import { render, staticRenderFns } from "./ProcedureModal.vue?vue&type=template&id=2e225380"
import script from "../../../scripts/partials/ProcedureModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/ProcedureModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports